import React from "react";
import * as Icon from "react-feather";

const ICON_BY_TOOL_NAME = {
	get_client_profile: Icon.User,
	list_client_contacts: Icon.AtSign,
	list_team_members: Icon.Users,
	load_skill: Icon.BookOpen,
	read_reference_file: Icon.FileText,
	get_previous_decisions: Icon.Clock,
	get_qbo_company_info: Icon.Briefcase,
	get_qbo_trial_balance: Icon.BarChart2,
	run_month_end_checks: Icon.CheckSquare,
	screen_gl_allocations: Icon.Filter,
	get_vendor_history: Icon.Repeat,
	get_qbo_general_ledger_for_account: Icon.List,
	get_qbo_journal_entries: Icon.BookOpen,
	get_qbo_tax_codes: Icon.Percent,
	get_qbo_profit_and_loss: Icon.TrendingUp,
	get_qbo_report: Icon.FileText,
	list_client_drive_files: Icon.Folder,
	read_client_drive_file: Icon.File,
	get_bank_feed_transactions: Icon.CreditCard,
	search_client_emails: Icon.Search,
	read_email_thread: Icon.Mail,
	list_my_meetings: Icon.Calendar,
	list_client_communications: Icon.MessageSquare,
	read_client_communication: Icon.Mic,
	list_client_engagements: Icon.Layers,
	list_engagement_stages: Icon.GitBranch,
	list_client_tasks: Icon.CheckCircle,
	list_client_notes: Icon.Edit2,
	propose_workflow_action: Icon.Edit3,
	create_excel_report: Icon.Grid,
	create_presentation: Icon.Monitor,
};

const ICON_BY_EFFECT = {
	reads_only: Icon.Eye,
	proposes: Icon.Edit3,
	produces_file: Icon.FilePlus,
};

class AgentToolIcon extends React.PureComponent {
	render() {
		const { tool, size = 15 } = this.props;
		const ToolGlyph = ICON_BY_TOOL_NAME[tool.name] || ICON_BY_EFFECT[tool.effect] || Icon.Tool;
		return <ToolGlyph size={size} />;
	}
}

export default AgentToolIcon;
